import * as types from '@/store/mutations'
import api from '@/services/auth'
import i18n from '@/i18n'

const getters = {
    token: (state) => state.token,
    isTokenSet: (state) => state.isTokenSet,
    user: (state)=> state.user,
    dealer: (state) => state.dealer,
    dealerDiscount: (state) => () =>{
        if(state.dealer == null){
            return 0
        } else {

            return state.dealer.discount
        }
    },
    dealerLocale: (state) => () =>{
        if(state.dealer == null){
            return 0
        } else {
            return state.dealer.locale
        }
    },
    dealerPrimaryAddress: (state) => ()=>{
        if(state.dealer == null){
            return {}
        } else {

            let add = state.dealer.person.primaryAddress
            return add.id
        }
    },
    dealerAddressesList: (state) =>{

            return state.addresses
     },
    dealerAddresses: (state) => () =>{


        if(state.dealer == null){
            return {}
        } else {
            let arr = {}
            state.addresses.map((add)=>{
                arr[add.id] = add.addressLine1+', '+add.postCode+' '+add.postLocation
            })

            return arr
        }
    },
    canHandIn: (state) => () =>{
        if(state.dealer == null){
            return false
        } else {
            return (state.dealer.orderHandinAllowed === 1)
        }
    },
    handinDisabledReason: (state) => () =>{
        if(state.dealer == null){
            return 'missing dealer'
        } else {
            return state.dealer.orderHandinReason
        }
    },
    dealerProfile: (state) => () =>{
        if(state.dealer == null){
            return 0
        } else {
            //console.log(JSON.stringify(state.dealer))
            return state.dealer.profile
        }
    }

}

const actions = {
    notification(){ /* handled in Notifications.vue */ },
    tokenLogin(store, payload) {
        return new Promise((resolve, reject)=>{
            api.authenticate(payload).then((res)=>{
                window.localStorage.setItem('authToken', JSON.stringify(res.data.token))
                store.commit(types.SAVE_TOKEN,res.data.token)
                store.commit(types.SET_SERVED_BY,res.data.servedBy)
                store.dispatch('loadUserData')
                    .then(()=> {

                        resolve() })
                    .catch(err => { reject(err) })
            }).catch(err => {
                reject(err)
            })
        })
    },
    listAddresses({commit}) {
        return new Promise((resolve, reject) => {
            api.listAllAddresses().then(res=>{
                commit(types.SET_ADDRESSES, res)
                resolve(res)
            }).catch((e) => {
                reject(e)
            })
        })
    },
    deleteAddress( store, payload ) {
        return new Promise((resolve, reject) => {

            if(payload){
                api.deleteAddress(payload).then(res1 =>{
                    api.listAllAddresses().then(res2=>{
                        store.commit(types.SET_ADDRESSES, res2)
                        resolve(res1)
                    }).catch((e) => {
                        reject(e)
                    })



                }).catch((e) => {
                    reject(e)
                })
            } else {
                //console.log('no address data')
            }


        })
    },

    addAddress( store, payload ) {
        return new Promise((resolve, reject) => {

            //console.log(payload)
            if(payload){
                api.addNewAddress(payload).then(res1 =>{
                    api.listAllAddresses().then(res2=>{
                        //console.log('list addressses api called')
                        //console.log(res2)
                        store.commit(types.SET_ADDRESSES, res2)
                        resolve(res1)
                    }).catch((e) => {
                        reject(e)
                    })



                }).catch((e) => {
                    reject(e)
                })
            } else {
              //console.log('no address data')
            }


        })
    },

    loadUserData(store){
        return new Promise((resolve, reject)=>{
            let usingCache = false
          //   let overrridden = false
          /*    const existingCache = JSON.parse(window.localStorage.getItem('profileCache'))
                
                const existingCacheLifetime = JSON.parse(
                window.localStorage.getItem('profileCacheLifetime')
                )
                if (existingCache && existingCacheLifetime) {
                //console.log("trying cache" + existingCacheLifetime)
                if (existingCache && existingCacheLifetime > Date.now() && overrridden) {
                store.commit(types.SET_USER, existingCache.user)
                store.commit(types.SET_DEALER, existingCache.dealer)
                usingCache = true
                resolve(1)
                }
                }
          */
          
            if(usingCache === false){
                api.me().then(res => {
                    store.commit(types.SET_USER, res.data.success)

                    api.dealer().then(resDealer => {
                        store.commit(types.SET_SERVED_BY, resDealer.data.servedBy)
                        store.commit(types.SET_DEALER, resDealer.data.data)
                        i18n.locale = resDealer.data.data.locale
                        window.localStorage.setItem(
                            'profileCache',
                            JSON.stringify({
                                user:res.data.success,
                                dealer:resDealer.data.data
                            })
                        )

                        const addedTime =  new Date();
                        const newLifetime = addedTime.setHours(addedTime.getHours() + 1)
                        window.localStorage.setItem(
                            'profileCacheLifetime',
                            JSON.stringify(newLifetime)
                        )


                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            }




        })
    },
    clearCache(store,type){
        return new Promise((resolve, reject)=>{
            let found = false

            if(type==="all"){
                window.localStorage.removeItem('categoryCache')
                window.localStorage.removeItem('categoryCacheLifetime')
                window.localStorage.removeItem('productCache')
                window.localStorage.removeItem('productCacheLifetime')
                window.sessionStorage.removeItem('customerCache')
                window.sessionStorage.removeItem('customerCacheLifetime')
                window.localStorage.removeItem('postCache')
                window.localStorage.removeItem('postCacheLifetime')
                window.localStorage.removeItem('profileCache')
                window.localStorage.removeItem('profileCacheLifetime')
                window.localStorage.removeItem('stockCache')
                window.localStorage.removeItem('stockCacheLifetime')
                found = true
            }

            if(type==="category"){
                window.localStorage.removeItem('categoryCache')
                window.localStorage.removeItem('categoryCacheLifetime')
                found = true
            }

            if(type==="product"){
                window.localStorage.removeItem('productCache')
                window.localStorage.removeItem('productCacheLifetime')
                found = true
            }

            if(type==="customer"){
                window.sessionStorage.removeItem('customerCache')
                window.sessionStorage.removeItem('customerCacheLifetime')
                found = true
            }

            if(type==="post"){
                window.localStorage.removeItem('postCache')
                window.localStorage.removeItem('postCacheLifetime')
                found = true
            }

            if(type==="profile"){
                window.localStorage.removeItem('profileCache')
                window.localStorage.removeItem('profileCacheLifetime')
                found = true
            }
            if(type==="stock"){
                window.localStorage.removeItem('stockCache')
                window.localStorage.removeItem('stockCacheLifetime')
                found = true
            }
            if(found){
                resolve()
                return
            }

            reject("clearCache needs type: 'category', 'product', 'customer', 'post' or 'all")
        })
    },
    logout({commit}){
        return new Promise((resolve)=>{
            window.localStorage.removeItem('categoryCache')
            window.localStorage.removeItem('categoryCacheLifetime')
            window.localStorage.removeItem('productCache')
            window.localStorage.removeItem('productCacheLifetime')
            window.sessionStorage.removeItem('customerCache')
            window.sessionStorage.removeItem('customerCacheLifetime')
            window.localStorage.removeItem('postCache')
            window.localStorage.removeItem('postCacheLifetime')
            window.localStorage.removeItem('authToken')
            window.localStorage.removeItem('profileCache')
            window.localStorage.removeItem('profileCacheLifetime')
            commit(types.LOGOUT)
            commit(types.SET_CUSTOMERS, [])
            commit(types.SET_PARTIES, [])
            commit(types.SET_CALENDAR_DATES, [])
            commit(types.SET_ACTIVE_PARTY, null)
            commit(types.SET_OPEN_ORDER, null)
            commit(types.SET_DEALER, null)
            commit(types.SET_ALL_SCORELOGS, [])
            resolve()
        })
    },
  reauth({commit}, payload){
    return new Promise((resolve,reject)=>{
      api.me().then((res)=>{
        commit(types.SET_USER, res.data.success)
        api.dealer().then(resDealer=>{

           commit(types.SET_SERVED_BY, resDealer.data.servedBy)
          payload.i18n.locale = resDealer.data.data.locale
          payload.moment.locale(resDealer.data.data.locale)
          commit(types.SET_DEALER, resDealer.data.data)
          resolve()
        }).catch((rejectDelaer)=>{
          reject(rejectDelaer)
        })
      }).catch((rej)=>{
        window.localStorage.removeItem('authToken')
        commit(types.LOGOUT)
        reject(rej)
      })
    })
  }
}

const mutations = {
    [types.SAVE_TOKEN](state, payload){
        state.token = payload
        state.isTokenSet = true
    },
    [types.LOGOUT](state){
        state.token = null
        state.isTokenSet = false
    },
    [types.SET_USER](state, payload){
        state.user.firstName = payload.firstName,
        state.user.lastName = payload.lastName
    },
    [types.SET_DEALER](state, payload){
        state.dealer = payload
    },
    [types.SET_ADDRESSES](state, payload){
        state.addresses = payload
    }
}

const state = {
    token: window.localStorage.getItem('authToken') || null,
    isTokenSet: !!window.localStorage.getItem('authToken'),
    dealer: null,
    locale:null,
    addresses:[],
    user: {
        firstName:'',
        lastName:''
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
